<template>
  <div class="pan-footer">
    <!--Social Icons Container-->
    <div class="pan-social">
      <a :href="$core.footerlinks.facebook" target="_blank">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a :href="$core.footerlinks.instagram" target="_blank">
        <i class="fab fa-instagram"></i>
      </a>
      <a :href="$core.footerlinks.youtube" target="_blank">
        <i class="fab fa-youtube"></i>
      </a>
    </div>

    <!--Contact and Legal-->
    <div class="pan-legal pan-mb20">
      <a :href="$core.header.homepage" target="_blank">{{ $t("footerlinks['mainSite']") }}</a>
    </div>

  </div>
</template>

<style lang="scss">

.pan-footer{
  padding:20px;
  background-color: #000;
  a,span{
    transition:all 0.3s ease-out;
    color:#fff;
  }
}

.pan-social{
  text-align:center;
  a{
    width:50px;
    display:inline-block;
    font-size:4px;
    font-size:calc(21px + 1vw);
    margin:20px;
    &:hover{
      transform:scale(1.1);
    }
    @media screen and (min-width:2500px){
      font-size:45px;
    }
  }
}

.pan-legal{
  text-align:center;
  white-space:nowrap;
  a{
    font-size: 14px;
    font-size: calc(12px + 0.1vw);
    display:inline-block;
    padding:0px 20px;
    &:hover{
      text-decoration:underline;
    }
  }
}



</style>

<script>
  export default{
    
  }
</script>


